import { Tooltip } from "@material-ui/core";
import IconDelete from "app/common/Icon/IconDelete";
import { observer } from "mobx-react";
import { memo } from "react";

const ButtonDeleteProgram = ({
  values,
  setFieldValue,
  handleChangeDiscount,
}) => {
  return (
    <>
      <Tooltip title="Xóa chương trình khuyến mãi">
        <div
          className="flex align-center gap-1"
          onClick={async () => {
            setFieldValue("promotionProgram", null);
            handleChangeDiscount(0);
          }}
        >
          <IconDelete />
        </div>
      </Tooltip>{" "}
    </>
  );
};
export default memo(observer(ButtonDeleteProgram));
